import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c(VContainer,{attrs:{"fluid":""}},[_c(VContainer,{staticClass:"text-center text-caption pb-0"},[_c('div',[_vm._v(" "+_vm._s(_vm.$store.getters.getAppSystemInfoCurrentVersion)+" ")]),_c('div',[_vm._v(" Copyright © "+_vm._s(_vm.year)+" TMX Mobile Solution Szerviz Kft. Minden jog fenntartva. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }